export default "__VITE_ASSET__C4SlV_E4__"